import { formattedBreakpoints as breakpoints } from './breakpoints'

export default {
  tiny: '@media only screen and (max-width: 360px)',
  small: `@media screen and (min-width: ${breakpoints[0]})`,
  medium: `@media screen and (min-width: ${breakpoints[1]})`,
  large: `@media screen and (min-width: ${breakpoints[2]})`
}
